export default __webpack_public_path__ + "static/char-s-10-kr-c468f603a44e52821934ba35e9693a94.webp";